<template>
  <v-dialog max-width="500px"
    v-model="openResolvePopup" persistent
    transition="dialog-transition"
  >
    <v-card v-if="companySettings.enable_resolution_summary === '1'">
      <v-card-title primary-title>
        Resolution summary
      </v-card-title>
      <v-card-text class="card-textarea">
        <v-textarea
          outlined
          :error-messages="errors.collect('Resolution summary')"
          :v-validate="companySettings.enable_resolution_summary === '2' ? 'min:150' : 'min:10'"
          name="Resolution summary"
          label="Resolution summary"
          placeholder="Please provide the resolution summary in atleast 150 words."
          v-model="rsummary"
        ></v-textarea>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-end">
        <v-btn text @click.stop="openResolvePopup=false;">Close</v-btn>
        <v-btn @click="onClickUpdateStatus" color="primary" class="white--text elevation-0" :loading="loading"
          :disabled="loading"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="companySettings.enable_resolution_summary === '2'">
      <v-card-title primary-title>
        Resolution summary
      </v-card-title>
      <v-card-text  class="card-textarea">
        <v-textarea
          outlined
          :error-messages="errors.collect('Resolution summary')"
          v-validate="'min:150|max:500'"
          name="Resolution summary"
          label="Resolution summary"
          placeholder="Please provide the resolution summary in atleast 150 words."
          v-model="rsummary"
        ></v-textarea>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-end">
        <v-btn text @click.stop="openResolvePopup=false;">Close</v-btn>
        <v-btn @click="validateDetails()" color="primary" class="white--text elevation-0" :loading="loading"
          :disabled="loading"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'RSummary',
  components: {},
  data () {
    return {
      loading: false,
      openResolvePopup: false,
      employee: null,
      status: [],
      rsummary: ''
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
      companySettings: state => state.csettings
    })
  },
  methods: {
    validateDetails () {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.onClickUpdateStatus();
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Resolution summary field must be at least 150 characters or may not be greater than 500 characters!'
          });
        }
      });
    },
    onClickUpdateStatus () {
      this.$parent.allData = {};
      this.$parent.allData.resolution_summary = this.rsummary;
      this.$parent.onClickUpdateStatusWithSummary();
      this.$nextTick(() => {
        this.open = false;
        this.openResolvePopup = false;
      });
    }
  },
  watch: {
    open () {
      this.loading = false;
      this.body.first_number = this.user.user_profile.phoneNumber;
      this.body.second_number = this.employee.phoneNumber;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.card-textarea {
  textarea {
    margin-right: 3px !important;
  }
}
</style>
